import { IUserInit } from "../factory/userInitFactory/interfaces/IUserInit";
import { CurrentUserRole } from "../factory/userInitFactory/types/CurrentUserRoleTypes";
import { UserInitFactory } from "../factory/userInitFactory/UserInitFactory";

export class UserLoggedInit{
    private currentUserRole:CurrentUserRole;
    private userInit: IUserInit;

    public constructor(currentUserRole:CurrentUserRole){
        this.currentUserRole = currentUserRole;
        this.userInit = UserInitFactory.createUserInit(this.currentUserRole);
    }

    public getDashboardUserRouteInit(){
        return this.userInit.getDashboardUserRoute();
    }
}